import {getRequest} from './request';

export function getStatus() {
  return getRequest('/api/v1/status');
}
